export default {
    "Panoramic": "https://www.celeusgroup.com/panoramic/",
    "Vitta": "https://www.celeusgroup.com/vitta/",
    "Natural": "https://www.celeusgroup.com/natural/",
    "Natural-A": "https://www.celeusgroup.com/natural/",
    "Natural-B": "https://www.celeusgroup.com/natural/",
    "Natural-C": "https://www.celeusgroup.com/natural/",
    "Classic": "https://www.celeusgroup.com/classic/",
    "Delux": "https://www.celeusgroup.com/delux/",
    "Delux-A": "https://www.celeusgroup.com/delux/",
    "Delux-B": "https://www.celeusgroup.com/delux/",
    "Delux-C": "https://www.celeusgroup.com/delux/",
}